function cov_26fzvpdt7() {
  var path = "/app/src/utils/default-fees-calculator.ts";
  var hash = "0d291a0a178e08f2309f1a816d94162ddbe5392f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/default-fees-calculator.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 23
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 80
        }
      },
      "2": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "calculateFeesByPrice",
        decl: {
          start: {
            line: 13,
            column: 16
          },
          end: {
            line: 13,
            column: 36
          }
        },
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "calculatePriceWithFees",
        decl: {
          start: {
            line: 21,
            column: 16
          },
          end: {
            line: 21,
            column: 38
          }
        },
        loc: {
          start: {
            line: 27,
            column: 3
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 27
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0d291a0a178e08f2309f1a816d94162ddbe5392f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26fzvpdt7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26fzvpdt7();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { INSTALLMENT_PLANS } from 'src/constants/learn-more';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';
var FEE_PERCENTAGE = (cov_26fzvpdt7().s[0]++, _defineProperty(_defineProperty(_defineProperty({}, INSTALLMENT_PLANS.six, 0.05), INSTALLMENT_PLANS.eight, 0.09), INSTALLMENT_PLANS.twelve, 0.17));
export function calculateFeesByPrice(price, installmentCount, currency) {
  cov_26fzvpdt7().f[0]++;
  cov_26fzvpdt7().s[1]++;
  return getFormattedAmount(price * FEE_PERCENTAGE[installmentCount], currency);
}
export function calculatePriceWithFees(_ref2) {
  var price = _ref2.price,
    installmentCount = _ref2.installmentCount;
  cov_26fzvpdt7().f[1]++;
  cov_26fzvpdt7().s[2]++;
  return price * FEE_PERCENTAGE[installmentCount] + price;
}